import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import { TextField, TextFieldProps } from 'components/text-field/text-field';
import { pick } from 'utils/pick';

type FormItemTextFieldProps = Omit<TextFieldProps, 'value' | 'onChange'>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    error: {
      color: theme.palette.error.main,
      fontWeight: 'normal',
      minHeight: '2em',
    },
  })
);

export function FormItemTextField(props: FormItemTextFieldProps) {
  const classes = useStyles();

  type TValue = string;

  const [field, meta, helpers] = useField<string>(props.name);

  const value: TValue = field.value || '';

  const handleChange = useCallback(
    (value: TValue) => {
      helpers.setValue(value);
    },
    [helpers]
  );

  const innerProps = pick(
    props,
    'label',
    'name',
    'type',
    'disabled',
    'multiline'
  );

  return (
    <>
      <div className={classes.error}>{meta.error}</div>
      <TextField value={value} onChange={handleChange} {...innerProps} />
    </>
  );
}
